import styled from 'styled-components';
import { Slider as SliderAntd } from 'antd';
import color from '../../configs/color';
import boxShadow from '../../configs/boxShadow';

const Slider = styled(SliderAntd)`
  .ant-slider {
    position: relative;
  }
  .ant-slider-rail {
    height: 6px;
  }
  .ant-slider-handle {
    height: 20px;
    width: 20px;
    margin-top: -7px;
    border: 1px solid ${color.grey1};
    box-shadow: ${boxShadow.normal};
  }
  .ant-slider-track {
    height: 6px;
    background-color: ${color.orange1};
  }
  .ant-slider-dot.ant-slider-dot-active {
    background-color: ${color.orange1};
    border: 1px solid ${color.grey5};
  }
  .ant-slider-dot {
    width: 12px;
    height: 12px;
    top: -3.5px;
    background-color: ${color.grey2};
    border: 1px solid ${color.grey5};
  }
  .ant-slider-mark {
    top: 20px;
    .ant-slider-mark-text {
      font-size: 14px;
      font-weight: 600;
      color: black;
    }
    span:first-child {
      transform: translateX(0) !important;
    }
    span:last-child {
      transform: translateX(-80%) !important;
    }
  }

  &.hide_slider_dots {
    .ant-slider-dot {
      display: none;
    }
  }
`;

export default Slider;
